export const OPEN_SIGNIN_DIALOG = 'OPEN_SIGNIN_DIALOG'
export const CLOSE_SIGNIN_DIALOG = 'CLOSE_SIGNIN_DIALOG'
export const OPEN_SIGNIN_DIALOG_TAB_CLICK = 'OPEN_SIGNIN_DIALOG_TAB_CLICK'

// -------------------- Action Creators

export const openSigninDialog = tabId => dispatch => {
  dispatch({ type: OPEN_SIGNIN_DIALOG, tabId: tabId || 'signIn' })
}

export const signinDialogTabClick = tabId => dispatch => {
  dispatch({ type: OPEN_SIGNIN_DIALOG_TAB_CLICK, tabId })
}

export const closeDialog = () => dispatch => dispatch({ type: CLOSE_SIGNIN_DIALOG })
